import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild}       from '@angular/core';
import {
  ApDynComponentComponent
}                                                                     from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynGridColumnConfigBase
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridEditColumnConfig
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  ApDynGridPropertyColumnConfig,
  FilterType,
  PropertyTemplate
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {filter, map}                                                  from 'rxjs/operators';
import {
  NFertilizationStore
}                                                                     from '../../stores/n-fertilization/n-fertilization.store';
import {BehaviorSubject, combineLatest, Observable, of, Subscription} from 'rxjs';
import {FieldStore}                                                   from '../../stores/farm/field.store';
import {CampaignYearStore}                                            from '../../stores/login/campaignyear.store';
import {LanguageStore}                                                from '../../stores/translation/language.store';
import {GetRoundNumericPipe}                                          from '../../ap-utils';
import {SettingsStore}                                                from '../../stores/base-data/settings.store';
import {ApUtilService}                                                from '../../ap-utils/service/ap-util.service';
import {
  ApShowPointsOnMapService
}                                                                     from '../../ap-utils/service/ap-show-points-on-map.service';
import {
  ApDynGridPagerConfigBase
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {
  ApDynGridPagerConfig,
  IGridPagerSubmitData
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {ApGridPagerType}                                              from '../../ap-interface';
import {TranslationStore}                                             from '../../stores/translation/translation.store';
import {
  ApNFertilizationLogfilesService
}                                                                     from '../services/ap-n-fertilization-logfiles.service';
import {
  ApDynGridGroupColumnConfig
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {FertilizerStore}                                              from '../../stores/base-data/fertilizer.store';
import {
  ApDynGridStatusSwitchColumnConfig,
  IStateChange
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-status-switch-column.config';
import {
  ApDynformsConfigFieldset
}                                                                     from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {FormStore}                                                    from '../../stores/layout/form.store';
import {
  ApNFertilizationLogfileEditComponent
}                                                                     from '../../entry-components/ap-n-fertilization-entry-components/ap-n-fertilization-logfile-edit.component';
import {DriverStore}                                                  from '../../stores/docu/driver.store';
import {ApDateService}                                                from '../../ap-core/services/ap-date-service';
import {CropTypeStore}                                                from '../../stores/base-data/crop.types.store';
import {
  CropApplicationStore
}                                                                     from '../../stores/task-management/crop-application.store';
import {
  GetRoundNumericService
}                                                                     from '../../ap-utils/service/get-round-numeric.service';
import {
  ApDynGridStatusColumnConfig
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {ObjectFactory}                                                from 'ts-tooling';
import {FertilizerService}                                            from '../../services/data/fertilizer.service';
import {
  NFertilizationService
}                                                                     from '../../services/data/n-fertilization.service';
import {MapFactoryStyler}                                             from '../../map-factory/style';
import {LoginStore}                                                   from '../../stores/login/login.store';
import {OperationModesEnum, OperationModesStore}                      from '../../stores/common/operation-modes.store';
import {LogfileService}                                               from '../../services/data/logfiles.service';
import IDatasetFieldMap = Data.Sensor.IDatasetFieldMap;
import IGuid = System.IGuid;
import IDriver = Data.DocuContext.Driver.IDriver;

export interface NFertilizationLogfilesGridData {
  Id: number;
  SourceItem: IDatasetFieldMap;
  DatasetId: IGuid;
  NContent: number;
  OperationMode: string;
  ApplicationMode: number;
  Status: number;
  StatusDesc: string;
  StatusClass: string;
  LogStatus: number;
  LogStatusDesc: string;
  LogStatusClass: string;
  Factor: number;
  FieldId: IGuid;
  FieldName: string;
  FieldGeomId: IGuid;
  FieldArea: number;
  FileName: string;
  Date: Date;
  Crop: string;
  Ec: number;
  FarmId: number;
  WorkedArea: number;
  WorkedAreaRounded: number;
  WorkingWidth: number;
  Amount: {
    Avg: number;
    AvgRounded: number;
    Value: number;
    ValueRounded: number;
    Product: number;
    ProductRounded: number;
  };
  NPlanBook: Data.TaskManagement.INFertilizationPlanBook;
  Appl: string;
  Planning: {
    Id: IGuid;
    SummaryId: IGuid;
    Date: Date;
    ProductId: number;
    Product: string;
    Note: string;
    Driver: IDriver;
  };
}

@Component({
  selector: 'ap-n-fertilization-logfiles',
  template: `
    <ap-dyncomponent [caption]="'Global__Logfiles'"
                     [canSearch]="true"
                     [loading$]="loading$"
                     [items]="items$ | async"
                     [headerIcon]="'ap-icon-n-fertilization'"
                     [pager]="pager"
                     [columns]="columns">
    </ap-dyncomponent>
  `,
  styles: []
})
export class ApNFertilizationLogfilesComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  public items$: Observable<NFertilizationLogfilesGridData[]> = of([]);
  public loading$: Observable<boolean> = of(true);
  public columns: ApDynGridColumnConfigBase[] = [];
  public fieldSets: ApDynformsConfigFieldset[];
  public pager: ApDynGridPagerConfigBase;

  private _isSaving$ = new BehaviorSubject<boolean>(false);
  private _selectedFieldIds = new BehaviorSubject<string[]>([]);
  private _subscriptions: Array<Subscription> = [];

  constructor(private nFertilizationLogfileService: ApNFertilizationLogfilesService,
              private campaignYearStore: CampaignYearStore,
              private loginStore: LoginStore,
              private cropApplicationStore: CropApplicationStore,
              private cropTypeStore: CropTypeStore,
              private driverStore: DriverStore,
              private fertilizerStore: FertilizerStore,
              private fieldStore: FieldStore,
              private showPointsOnMapService: ApShowPointsOnMapService,
              private languageStore: LanguageStore,
              private nFertilization: NFertilizationStore,
              private formStore: FormStore,
              private roundNumericPipe: GetRoundNumericPipe,
              private roundNumericService: GetRoundNumericService,
              private settingStore: SettingsStore,
              private translationStore: TranslationStore,
              private dateService: ApDateService,
              private nFertilizationService: NFertilizationService,
              private fertilizerService: FertilizerService,
              private operationModeStore: OperationModesStore,
              private logfileService: LogfileService) {
  }

  public ngOnInit(): void {
    this.loading$ = combineLatest([
      this.nFertilization.Listen(s => s.logfilesLoading),
      this.nFertilization.Listen(s => s.loading),
      this.fieldStore.Listen(s => s.loading),
      this.cropApplicationStore.Listen(s => s.loading),
      this._isSaving$,
      this.nFertilization.Listen(s => s.planBooksLoading)
    ]).pipe(map(([l0, l1, l2, l3, saving, l4]) => {
      return l0 || l1 || l2 || l3 || saving || l4;
    }));

    this._gridBuilder();
  }

  public ngAfterViewInit(): void {
    this._subscriptions.push(this.campaignYearStore.Listen(s => s.selectedYear).subscribe(() => setTimeout(() => {
      this.nFertilization.LoadNFertilizationPlanningSummaries();
      this.nFertilization.LoadLogfiles();
    })));
    this._subscriptions.push(this.campaignYearStore.onLoadingStoresComplete.subscribe(() => {
      this.showPointsOnMapService.clear();
    }));
    this._subscriptions.push(this.loading$.subscribe(loading => {
      if (!loading) {
        this.dynComponent.dynGrid.gridPaging.setSelectedKeys([]);
      }
    }));

    this._subscriptions.push(this.dynComponent.SelectedItems$.pipe(
      map((items) => items.map((item) => item.FieldId).filter((v, i, a) => a.indexOf(v) === i)),
    ).subscribe((ids) => {
      this._selectedFieldIds.next(ids);
      this.fieldStore.changeSelectedField(ids);
    }));
    setTimeout(() => this._getDataFromStore(), 1);
    this._subscriptions.push(this.dynComponent.SelectedItems$.subscribe(selectedItems => {
      MapFactoryStyler.Instance.clearStyleCache();
      this.nFertilizationLogfileService.toggleLogPointsOnMap(selectedItems, this.loginStore.SelectedFarmId);
    }));
  }

  public ngOnDestroy(): void {
    this.showPointsOnMapService.clear();
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  private _gridBuilder(): void {
    this.fieldSets = undefined;
    this.columns = [
      new ApDynGridStatusColumnConfig({
        field: 'Status',
        class: 'StatusClass',
        description: 'StatusDesc',
        groupDesc: true
      }),
      new ApDynGridStatusSwitchColumnConfig({
        field: 'LogStatus',
        readonly: true,
        filterable: true,
        defaultFilter: 0,
        disableGreen: (item) => !this._logFileValid(item.SourceItem) || !this._logBookingReady(item.SourceItem),
        stateChange: ApUtilService.createEventEmitter(
          (event: IStateChange) => {
            if (event.state === -1) {
              this.nFertilizationLogfileService.onReject(event.item);
            } else if (event.state === 0) {
              this.nFertilizationLogfileService.onReset(event.item);
            } else if (event.state === 1) {
              this.nFertilizationLogfileService.onAccept(event.item);
            }
          }, this._subscriptions),
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__FieldName',
        field: 'FieldName',
        width: 180,
        headerFilterable: true,
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global_ha_Unit',
        field: 'FieldArea',
        width: 60,
        headerFilterable: true,
        cssClass: 'right',
        filterType: FilterType.NUMBER,
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [this.settingStore.FirstSetting.DigitsAfterDecimalPoint]
        }]
      }),
      new ApDynGridGroupColumnConfig({
        title: 'N__Logfile',
        groupColumns: [
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Filename',
            field: 'FileName',
            width: 100,
            filterable: true,
            headerFilterable: true,
            hide: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Date',
            field: 'Date',
            format: this.languageStore.SelectedLanguage.DateFormat,
            width: 80,
            filterable: true,
            headerFilterable: true,
            sortIndex: 0,
            sortDesc: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Crop',
            field: 'Crop',
            width: 100,
            headerFilterable: true,
            filterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__ECStageShort',
            field: 'Ec',
            width: 40,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            filterable: true,
            headerFilterable: true,
            hide: true
          }),
          new ApDynGridPropertyColumnConfig({
            field: 'Appl',
            title: 'Global__N_ApplNum',
            width: 40,
            headerFilterable: true,
            filterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Area',
            field: 'WorkedAreaRounded',
            tooltip: (dataItem) => this.roundNumericPipe.transform(dataItem['WorkedArea'], 4),
            width: 60,
            hide: true,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            headerFilterable: true,
            filterable: true,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [this.settingStore.FirstSetting.DigitsAfterDecimalPoint]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Average_Amount',
            field: 'Amount.AvgRounded',
            headerExtraLines: ['Global__KgNPerHa'],
            tooltip: (dataItem) => this.roundNumericPipe.transform(dataItem['Amount']['Avg']),
            width: 60,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            headerFilterable: true,
            filterable: true,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [this.settingStore.FirstSetting.DigitsAfterDecimalPoint]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Sum_Goods',
            field: 'Amount.ProductRounded',
            headerExtraLines: ['Global__Unit_kg'],
            width: 60,
            cssClass: 'right',
            dynCssClass: (dataItem: any) => dataItem['Factor'] !== 1.0 ? ' italic bold' : '',
            filterType: FilterType.NUMBER,
            headerFilterable: true,
            filterable: true,
            hide: true,
            tooltip: (dataItem) => `${this.roundNumericService.round(dataItem['Amount']['Value'],
              this.settingStore.FirstSetting.DigitsAfterDecimalPoint)}
              ${this.translationStore.FindTranslationForSelectedLanguage('Global__Unit_kgN')}`,
          })
        ]
      }),
      new ApDynGridGroupColumnConfig({
        title: 'Global__Planning',
        hide: true,
        groupColumns: [
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Product',
            field: 'Planning.Product',
            width: 100,
            headerFilterable: true,
            filterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Date',
            field: 'Planning.Date',
            format: this.languageStore.SelectedLanguage.DateFormat,
            width: 80,
            headerFilterable: true,
            filterable: true,
            filterType: FilterType.DATE,
            template: PropertyTemplate.DATE
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Motorist',
            field: 'Planning.Driver.ShortFullName',
            width: 100,
            headerFilterable: true,
            filterable: true
          }),
        ]
      }),
      new ApDynGridEditColumnConfig({
        data: [
          {
            text: 'Global__Edit',
            callback: ApUtilService.createEventEmitter(this._onEdit.bind(this), this._subscriptions),
            disabled: (item) => item.LogStatus === 1 || item.Status === -1
          },
          {
            text: 'Global__Booking',
            callback: ApUtilService.createEventEmitter(this._onBooking.bind(this), this._subscriptions),
            disabled: (item) => !this._logFileValid(item.SourceItem) || !this._logBookingReady(item.SourceItem) || this._logBooked(item.SourceItem)
          },
          {
            text: 'Global__Reject',
            callback: ApUtilService.createEventEmitter(this._onReject.bind(this), this._subscriptions),
            disabled: false
          },
          {
            text: 'Global__Logfile_Remap',
            callback: ApUtilService.createEventEmitter(this._onRemap.bind(this), this._subscriptions),
            disabled: (item) => item.LogStatus === 1
          }
        ]
      })
    ];

    this.pager = new ApDynGridPagerConfig({
      preselect: false,
      listMassEditing: [
        {
          id: 0,
          name: this.translationStore.FindTranslationForSelectedLanguage('Docu_Ini__Edit'),
          type: ApGridPagerType.None,
          formConfig: this.nFertilizationLogfileService.getEditFieldSets(),
          disabled: (properties) => properties.selectedItems.some((item) => item.Status !== 1 || item.LogStatus !== 0),
          values: [],
          onSubmit: ApUtilService.createEventEmitter(
            (event: IGridPagerSubmitData) => {
              this._isSaving$.next(true);
              this.nFertilizationLogfileService.update(event.items, event.form.value);
            }
            , this._subscriptions)
        },
        {
          id: 4,
          name: this.translationStore.FindTranslationForSelectedLanguage('Global__Generate_Planning'),
          type: ApGridPagerType.None,
          disabled: (properties) => properties.selectedItems.some((item) => item.Status !== 0) ||
            properties.selectedItems.every((item: any) => item.NPlanBook != null),
          values: [],
          onSubmit: ApUtilService.createEventEmitter(
            (event: IGridPagerSubmitData) => this.nFertilizationLogfileService.generatePlanning(event.items), this._subscriptions)
        },
        {
          id: 1,
          name: this.translationStore.FindTranslationForSelectedLanguage('Admin_Pages_Popups__Book'),
          type: ApGridPagerType.None,
          disabled: (properties) =>
            properties.selectedItems.some((item: any) => !this._logFileValid(item.SourceItem) || !this._logBookingReady(item.SourceItem)) ||
            properties.selectedItems.every((item: any) => this._logBooked(item.SourceItem)),
          values: [],
          onSubmit: ApUtilService.createEventEmitter(
            (event: IGridPagerSubmitData) => {
              this._isSaving$.next(true);
              this.nFertilizationLogfileService.onAccept(event.items.filter((item) => !this._logBooked(item.SourceItem)));
            }, this._subscriptions)
        },
        {
          id: 5,
          name: this.translationStore.FindTranslationForSelectedLanguage('Global__Reset'),
          type: ApGridPagerType.None,
          disabled: (properties) =>
            properties.selectedItems.some((item: any) => item.LogStatus === 0),
          values: [],
          onSubmit: ApUtilService.createEventEmitter(
            (event: IGridPagerSubmitData) => {
              this._isSaving$.next(true);
              this.nFertilizationLogfileService.onReset(event.items);
            }, this._subscriptions)
        },
        {
          id: 2,
          name: this.translationStore.FindTranslationForSelectedLanguage('Global__Reject'),
          type: ApGridPagerType.None,
          values: [],
          onSubmit: ApUtilService.createEventEmitter(
            (event: IGridPagerSubmitData) => {
              this._isSaving$.next(true);
              this.nFertilizationLogfileService.onReject(event.items);
            }, this._subscriptions)
        },
        {
          id: 3,
          name: this.translationStore.FindTranslationForSelectedLanguage('Global__Logfile_Remap'),
          type: ApGridPagerType.None,
          disabled: (properties) => properties.selectedItems.some((item: any) => this._logBooked(item.SourceItem)),
          values: [],
          onSubmit: ApUtilService.createEventEmitter(
            (event: IGridPagerSubmitData) => {
              this._onRemap(event.items);
            }, this._subscriptions)
        },
      ],
    });
  }

  private _onEdit(dataItem: any): void {
    this.formStore.openForm({component: ApNFertilizationLogfileEditComponent, data: dataItem});
  }

  private _onBooking(dataItem: any): void {
    this._isSaving$.next(true);
    this.nFertilizationLogfileService.onAccept(dataItem.SourceItem);
  }

  private _onReject(dataItem: any): void {
    this._isSaving$.next(true);
    this.nFertilizationLogfileService.onReject([dataItem]);
  }

  private _onRemap(dataItem: any | any[]): void {
    if (Array.isArray(dataItem)) {
      this.nFertilization.remapLogfile(dataItem.map((d) => d['DatasetId']));
    } else {
      this.nFertilization.remapLogfile(dataItem['DatasetId']);
    }
  }

  private _getDataFromStore(): void {
    this.items$ = combineLatest([
      this.nFertilization.Listen(s => s.logfiles),
      this.fieldStore.Listen(s => s.data),
      this.cropApplicationStore.Listen(s => s.data),
      this.nFertilization.Listen(s => s.planBooks),
      this.nFertilization.Listen(s => s.planBooksLoading)
    ]).pipe(
      filter(([, fields, ca, , planBooksLoading]) => !!fields && fields.length !== 0 && ca.length !== 0 && !planBooksLoading),
      map(([logfiles, , , planBooks]) => {
          this._isSaving$.next(false);
          return logfiles
            .filter((logfile) => logfile?.DataSet?.DataSetType?.DataSetName === 'Yara N-Sensor')
            .map((logfile) => {
              logfile = ObjectFactory.Copy(logfile);
              const filename = logfile.DataSet.DataSetName.Substring(0, logfile.DataSet.DataSetName.lastIndexOf('.'));
              const planning = logfile.NPlanBook ?? this.logfileService.getPlanning(logfile, planBooks);
              if (planning) {
                logfile.NPlanBook = planning;
              }
              const headerValues = JSON.parse(logfile.DataSet.HeaderValuesString);
              const content = !!headerValues['AgentContent'] ? Number.parseInt(headerValues['AgentContent'].split(' ').shift(), 0) : null;
              const value = logfile.NContentAvg * logfile.Area;
              const status = !this._logFileValid(logfile) ? -1 : this._logBookingReady(logfile) ? 1 : 0;
              const logStatus = this._logIsRejected(logfile) ? -1 : this._logBooked(logfile) ? 1 : 0;
              const driver = this.driverStore.getDriverById(planning?.ExportDriver);
              const fieldId = this.fieldStore.getFieldByFieldGeomId(logfile.FieldGeomId)?.Id;
              const fieldName = this.fieldStore.getFieldNameById(fieldId, 'Global__UnknownFieldName');
              const fertilizer = this.fertilizerStore.getFertilizer(planning?.ProductId);
              const operationMode = headerValues['OperationMode']?.toString();
              return {
                Id: logfile.Id,
                SourceItem: logfile,
                DatasetId: logfile.DataSet.Id,
                NContent: content,
                OperationMode: operationMode,
                ApplicationMode: logfile.ApplicationMode,
                Status: status,
                StatusDesc: status === 1 ? 'Global__Logfile_Ok' : status === -1 ? 'Global__Logfile_Field_Geom_Error' : 'Global__Logfile_Action_Needed',
                StatusClass: status === 1 ? 'ap-status-green' : status === -1 ? 'ap-status-red' : 'ap-status-yellow',
                LogStatus: logStatus,
                LogStatusDesc: logStatus === 1 ? 'Admin_Pages_Popups__Book' : logStatus === -1 ? 'Global__Reject' : 'Global__Reset',
                LogStatusClass: logStatus === 1 ? 'ap-status-green' : logStatus === -1 ? 'ap-status-red' : 'ap-status-yellow',
                Factor: logfile.Factor,
                FieldId: fieldId,
                FieldName: fieldName,
                FieldGeomId: logfile.FieldGeomId,
                FieldArea: this.fieldStore.getFieldGeomById(logfile.FieldGeomId)?.AreaHa ?? logfile.Area,
                FileName: filename,
                Date: this.dateService.getDateMidnight(logfile.DataSet.Created),
                Crop: this.translationStore.FindTranslationForSelectedLanguage(this.cropTypeStore.getDefaultCroptype(logfile.CropType)?.Description),
                Ec: logfile.Ec,
                FarmId: logfile.FarmId,
                WorkedArea: logfile.Area,
                WorkedAreaRounded: this.roundNumericService.roundAsNumber(logfile.Area),
                WorkingWidth: logfile.WorkingWidth ? logfile.WorkingWidth : JSON.parse(logfile.DataSet.HeaderValuesString)['WorkingWidth'],
                Amount: {
                  Avg: logfile.NContentAvg,
                  AvgRounded: this.roundNumericService.roundAsNumber(logfile.NContentAvg ?? value),
                  Value: logfile.Amount ?? value,
                  ValueRounded: this.roundNumericService.roundAsNumber(logfile.Amount ?? value) ?? 0,
                  Product: this.logfileService.calculateLogFileProductFromAmountN( logfile.Amount, content),
                  ProductRounded: this.roundNumericService.roundAsNumber(this.logfileService.calculateLogFileProductFromAmountN( logfile.Amount, content)),
                },
                NPlanBook: planning,
                Appl: operationMode === this.operationModeStore.getIOperationModeByKey(OperationModesEnum.Bonitur)?.LoggerId.toString()
                  ? this.nFertilizationService.getApplicationNScanRateName()
                  : this.nFertilizationService.getApplicationRateName(this.cropTypeStore.getDefaultCroptype(logfile.CropType)?.Eppocode, logfile.Ec),
                Planning: {
                  Id: planning?.Id,
                  SummaryId: planning?.Summary?.Id,
                  Date: planning?.ApplicationDate ? this.dateService.getDateMidnight(planning.ApplicationDate) : null,
                  ProductId: planning?.ProductId,
                  Product: this.fertilizerService.getFertilizerProductName(fertilizer),
                  Note: planning?.Summary?.Title,
                  Driver: driver
                }
              } as NFertilizationLogfilesGridData;
            });
        }
      ),
    );
  }

  private _logFileValid(item: IDatasetFieldMap): boolean {
    const json = JSON.parse(item.DataSet.HeaderValuesString);
    return !!this.fieldStore.getFieldByFieldGeomId(item?.FieldGeomId) &&
      !!item.CropType && !!json['CropType'] &&
      item.Ec != null && json['EcStage'] != null &&
      item.ApplicationMode != null && json['ApplicationMode'] != null;
  }

  private _logBookingReady(item: IDatasetFieldMap): boolean {
    if (!item?.NPlanBook || item?.NPlanBook?.ProductId == null) {
      return false;
    }
    const fertilizer = this.fertilizerStore.getFertilizer(item?.NPlanBook?.ProductId);
    if (!fertilizer?.Selectable && item?.NPlanBook?.ProductId !== 0) {
      return false;
    }
    return item?.Ec > 9 && item?.Ec < 70 && item?.WorkingWidth >= 10 && item?.WorkingWidth <= 100;
  }

  private _logIsRejected(item: IDatasetFieldMap): boolean {
    return item?.Status === -1;
  }

  private _logBooked(item: IDatasetFieldMap): boolean {
    return item?.Status === 1 && item?.NPlanBook?.BookedBy != null;
  }
}
